/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListNotesParams,
  NoteIn,
  NoteOut,
  PaginatedNoteOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listNotesResponse200 = {
  data: PaginatedNoteOut
  status: 200
}

export type listNotesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listNotesResponseSuccess = (listNotesResponse200) & {
  headers: Headers;
};
export type listNotesResponseError = (listNotesResponse422) & {
  headers: Headers;
};

export type listNotesResponse = (listNotesResponseSuccess | listNotesResponseError)

export const getListNotesUrl = (params: ListNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notes?${stringifiedParams}` : `/api/notes`
}

/**
 * @summary List Notes
 */
export const listNotes = async (params: ListNotesParams, options?: Parameters<typeof apiFetch>[1]): Promise<listNotesResponse> => {

  return apiFetch<listNotesResponse>(getListNotesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotesQueryKey = (params?: ListNotesParams,) => {
    return [
    `/api/notes`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotesQueryOptions = <TData = Awaited<ReturnType<typeof listNotes>>, TError = HTTPValidationError>(params: ListNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotes>>> = ({ signal }) => listNotes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNotesQueryResult = NonNullable<Awaited<ReturnType<typeof listNotes>>>
export type ListNotesQueryError = HTTPValidationError


export function useListNotes<TData = Awaited<ReturnType<typeof listNotes>>, TError = HTTPValidationError>(
 params: ListNotesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotes>>,
          TError,
          Awaited<ReturnType<typeof listNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotes<TData = Awaited<ReturnType<typeof listNotes>>, TError = HTTPValidationError>(
 params: ListNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotes>>,
          TError,
          Awaited<ReturnType<typeof listNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotes<TData = Awaited<ReturnType<typeof listNotes>>, TError = HTTPValidationError>(
 params: ListNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Notes
 */

export function useListNotes<TData = Awaited<ReturnType<typeof listNotes>>, TError = HTTPValidationError>(
 params: ListNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNotesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type addNoteResponse201 = {
  data: NoteOut
  status: 201
}

export type addNoteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type addNoteResponseSuccess = (addNoteResponse201) & {
  headers: Headers;
};
export type addNoteResponseError = (addNoteResponse422) & {
  headers: Headers;
};

export type addNoteResponse = (addNoteResponseSuccess | addNoteResponseError)

export const getAddNoteUrl = () => {




  return `/api/notes`
}

/**
 * @summary Add Note
 */
export const addNote = async (noteIn: NoteIn, options?: Parameters<typeof apiFetch>[1]): Promise<addNoteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<addNoteResponse>(getAddNoteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(noteIn)
  }
);}





export const getAddNoteMutationKey = () => ['addNote'] as const;

export const getAddNoteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNote>>, TError,AddNoteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addNote>>, TError,AddNoteMutationVariables, TContext> => {

const mutationKey = getAddNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addNote>>, AddNoteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addNote(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddNoteMutationResult = NonNullable<Awaited<ReturnType<typeof addNote>>>
    export type AddNoteMutationBody = NoteIn
    export type AddNoteMutationError = HTTPValidationError
    export type AddNoteMutationVariables = {data: NoteIn}

    /**
 * @summary Add Note
 */
export const useAddNote = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addNote>>, TError,AddNoteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addNote>>,
        TError,
        AddNoteMutationVariables,
        TContext
      > => {
      return useMutation(getAddNoteMutationOptions(options), queryClient);
    }
    export type deleteNoteResponse204 = {
  data: void
  status: 204
}

export type deleteNoteResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteNoteResponseSuccess = (deleteNoteResponse204) & {
  headers: Headers;
};
export type deleteNoteResponseError = (deleteNoteResponse422) & {
  headers: Headers;
};

export type deleteNoteResponse = (deleteNoteResponseSuccess | deleteNoteResponseError)

export const getDeleteNoteUrl = (noteId: number,) => {




  return `/api/notes/${noteId}`
}

/**
 * @summary Delete Note
 */
export const deleteNote = async (noteId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteNoteResponse> => {

  return apiFetch<deleteNoteResponse>(getDeleteNoteUrl(noteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteNoteMutationKey = () => ['deleteNote'] as const;

export const getDeleteNoteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNote>>, TError,DeleteNoteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNote>>, TError,DeleteNoteMutationVariables, TContext> => {

const mutationKey = getDeleteNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNote>>, DeleteNoteMutationVariables> = (props) => {
          const {noteId} = props ?? {};

          return  deleteNote(noteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNote>>>

    export type DeleteNoteMutationError = HTTPValidationError
    export type DeleteNoteMutationVariables = {noteId: number}

    /**
 * @summary Delete Note
 */
export const useDeleteNote = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNote>>, TError,DeleteNoteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNote>>,
        TError,
        DeleteNoteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteNoteMutationOptions(options), queryClient);
    }
